// covered-by: frontends/carrie/src/routes/auth-layout/__tests__/authLayoutRoute.test.tsx
import { waitForFeatureFlags } from "../../config/featureFlags";

// why: PostHog flags are undefined until the async PostHog callback; the KB
// guard treats undefined as deny-to-home. Wrapping the wait in a single named
// export enforces the invariant structurally — both authenticated layouts call
// this function, and the cross-layout contract test in
// __tests__/authLayoutRoute.test.tsx scans every rootRoute-child layout whose
// id ends in "authenticated" for this call, so a new layout that omits it
// fails the test rather than silently re-introducing the bug.
//
// The layout suites in that file mock this module out, so the delegation below
// is pinned separately by its `describe("requireFlagsLoaded")` block, which
// loads this module un-mocked and asserts the returned promise is identically
// waitForFeatureFlags()'s — a body that allocates its own resolved promise
// (i.e. no wait at all) fails there.
export function requireFlagsLoaded(): Promise<void> {
  return waitForFeatureFlags();
}
